(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dixie-employment"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var form = document.getElementById('das-emp-form');
    if (!form) return;
    var btn = document.getElementById('das-emp-submit');
    var result = document.getElementById('das-emp-result');
    var messageField = document.getElementById('das-emp-message');

    function val(field) {
      var v = field.value ? field.value.trim() : '';
      return v || '\u2014';
    }

    function buildSummary() {
      var lines = [];
      var push = function (s) { lines.push(s === undefined ? '' : s); };

      var f = {};
      form.querySelectorAll('[data-f]').forEach(function (el) {
        var key = el.getAttribute('data-f');
        if (el.type === 'checkbox') {
          if (el.checked) f[key] = 'Yes';
        } else if (el.type === 'radio') {
          if (el.checked) f[key] = el.value;
        } else {
          f[key] = val(el);
        }
      });

      push('POSITION');
      push('Applied for: ' + (f['Position'] || '\u2014'));
      push('');

      push('APPLICANT');
      push((f['First Name'] || '') + ' ' + (f['Last Name'] || ''));
      push('Phone: ' + (f['Phone'] || '\u2014') + '   Email: ' + (f['Email'] || '\u2014'));
      var addr = (f['Street Address'] || '') + (f['Street Address Line 2'] ? ', ' + f['Street Address Line 2'] : '') + ', ' + (f['City'] || '') + ', ' + (f['State'] || '') + ' ' + (f['Zip Code'] || '');
      push('Address: ' + addr);
      push('DOB: ' + (f['Date of Birth'] || '\u2014') + '   Desired pay: ' + (f['Salary Desired'] ? '$' + f['Salary Desired'] + '/hr' : '\u2014'));
      push('');

      push('AVAILABILITY');
      var sched = [];
      if (f['Schedule: Full-Time']) sched.push('Full-Time');
      if (f['Schedule: Part-Time']) sched.push('Part-Time');
      push('Schedule sought: ' + (sched.length ? sched.join(', ') : '\u2014'));
      push('Currently employed: ' + (f['Currently Employed'] || '\u2014'));
      push('');

      push('EXPERIENCE');
      push('Owns general tools: ' + (f['Owns General Tools'] || '\u2014') + '   Owns power tools: ' + (f['Owns Power Tools'] || '\u2014'));
      push('Removed 20+ engines/trans: ' + (f['Removed 20+ Engines/Trans'] || '\u2014'));
      push('Makes worked on: ' + (f['Makes Worked On'] || '\u2014'));
      var edu = [];
      ['GED', 'High School Diploma', 'Some College', 'College Degree', 'Some Trade School', 'Trade School Graduate'].forEach(function (label) {
        if (f['Education: ' + label]) edu.push(label);
      });
      push('Education: ' + (edu.length ? edu.join(', ') : '\u2014'));
      push('Favorite vehicle: ' + (f['Favorite Vehicle'] || '\u2014'));
      push('');

      push('EMPLOYMENT HISTORY');
      push('- Most recent: ' + (f['RE Company'] || '\u2014') + ' | Contact: ' + (f['RE Contact Name'] || '\u2014') + ' | ' + (f['RE Phone'] || '\u2014'));
      if (f['RE Ending Salary']) push('  Ending wage: $' + f['RE Ending Salary'] + '/hr');
      if (f['RE Favorite']) push('  Favorite: ' + f['RE Favorite']);
      if (f['RE Least Favorite']) push('  Least favorite: ' + f['RE Least Favorite']);
      push('- Previous: ' + (f['PE Company'] || '\u2014') + ' | Contact: ' + (f['PE Contact Name'] || '\u2014') + ' | ' + (f['PE Phone'] || '\u2014'));
      if (f['PE Ending Salary']) push('  Ending wage: $' + f['PE Ending Salary'] + '/hr');
      if (f['PE Favorite']) push('  Favorite: ' + f['PE Favorite']);
      if (f['PE Least Favorite']) push('  Least favorite: ' + f['PE Least Favorite']);
      push('');

      push('REFERENCES');
      push('- ' + (f['Ref1 First Name'] || '') + ' ' + (f['Ref1 Last Name'] || '') + ' | ' + (f['Ref1 Phone'] || '\u2014') + ' | ' + (f['Ref1 Relationship'] || '\u2014'));
      push('- ' + (f['Ref2 First Name'] || '') + ' ' + (f['Ref2 Last Name'] || '') + ' | ' + (f['Ref2 Phone'] || '\u2014') + ' | ' + (f['Ref2 Relationship'] || '\u2014'));
      push('');

      push('MILITARY SERVICE: ' + (f['Military Service'] || '\u2014'));
      push('');

      push('ACKNOWLEDGEMENT (1 disagree - 5 fully agree)');
      push('Outdoor work: ' + (f['Ack: Outdoor Work (1-5)'] || '\u2014') + '/5');
      push('Dirt and grease: ' + (f['Ack: Dirt and Grease (1-5)'] || '\u2014') + '/5');
      push('Team reliability: ' + (f['Ack: Team Reliability (1-5)'] || '\u2014') + '/5');
      push('Certifies answers true and complete: ' + (f['Certification'] || '\u2014'));

      return lines.join('\n');
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      btn.disabled = true;
      var original = btn.textContent;
      btn.textContent = 'Sending...';
      result.className = 'das-emp__result';
      result.textContent = '';

      messageField.value = buildSummary();

      var data = new FormData(form);

      fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        body: data,
        headers: { 'Accept': 'application/json' }
      })
      .then(function (res) { return res.json(); })
      .then(function (json) {
        if (json.success) {
          result.className = 'das-emp__result is-ok';
          result.textContent = form.getAttribute('data-success') || 'Thanks, your application is in.';
          form.reset();
          btn.textContent = original;
        } else {
          result.className = 'das-emp__result is-err';
          result.textContent = 'Something went wrong - please call the yard or try again.';
          btn.disabled = false;
          btn.textContent = original;
        }
      })
      .catch(function () {
        result.className = 'das-emp__result is-err';
        result.textContent = 'Something went wrong - please call the yard or try again.';
        btn.disabled = false;
        btn.textContent = original;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  (function () {
    var tabs = document.querySelectorAll('.rta-tabs');
    if (!tabs.length) return;
    tabs.forEach(function (tabsEl) {
      if (tabsEl.dataset.rtaTabsInit === 'true') return;
      tabsEl.dataset.rtaTabsInit = 'true';
      var buttons = tabsEl.querySelectorAll('.rta-tabs__button');
      var panels = tabsEl.querySelectorAll('.rta-tabs__panel');
      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var target = btn.getAttribute('data-rta-tab');
          buttons.forEach(function (b) { b.classList.remove('rta-tabs__button--active'); b.setAttribute('aria-selected', 'false'); });
          panels.forEach(function (p) { p.classList.remove('rta-tabs__panel--active'); });
          btn.classList.add('rta-tabs__button--active');
          btn.setAttribute('aria-selected', 'true');
          var activePanel = tabsEl.querySelector('[data-rta-panel="' + target + '"]');
          if (activePanel) activePanel.classList.add('rta-tabs__panel--active');
        });
      });
    });
  })();

  // Position the in-stock line under the product title in the buy column.
  (function () {
    function placeChip() {
      var chip = document.querySelector('product-meta-chip.das-meta');
      if (!chip || chip.dataset.placed === 'true') return;
      var title = document.querySelector('.product-information h1') || document.querySelector('.shopify-section h1');
      if (!title) return;
      title.insertAdjacentElement('afterend', chip);
      chip.removeAttribute('hidden');
      chip.dataset.placed = 'true';
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', placeChip);
    } else {
      placeChip();
    }
    setTimeout(placeChip, 400);
  })();

  // Relocate the Item Details box into the buy column, after the buy buttons.
  (function () {
    function relocate() {
      var box = document.querySelector('product-item-details.das-item-details');
      if (!box || box.dataset.moved === 'true') return;
      var buyBtns = document.querySelector('.buy-buttons-block, .product-information product-form, .product-form');
      if (!buyBtns) return;
      var col = buyBtns.closest('.group-block-content') || buyBtns.parentElement;
      if (!col) return;
      col.appendChild(box);
      box.removeAttribute('hidden');
      box.dataset.moved = 'true';
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', relocate);
    } else {
      relocate();
    }
    setTimeout(relocate, 400);
  })();

  // Custom solid-white gallery arrows (Horizon's glass arrows are hidden via CSS)
  (function () {
    function buildArrows() {
      var slideshow = document.querySelector('.product-information slideshow-component');
      if (!slideshow || slideshow.dataset.customArrows === 'true') return;
      var container = slideshow.querySelector('slideshow-container') || slideshow;
      if (!container) return;
      slideshow.dataset.customArrows = 'true';
      if (getComputedStyle(container).position === 'static') container.style.position = 'relative';
      var chevL = '<svg viewBox="0 0 24 24" fill="none" stroke="#0E0E0E" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="m15 18-6-6 6-6"/></svg>';
      var chevR = '<svg viewBox="0 0 24 24" fill="none" stroke="#0E0E0E" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"/></svg>';
      var prev = document.createElement('button');
      prev.type = 'button'; prev.className = 'das-custom-arrow das-custom-arrow--prev'; prev.setAttribute('aria-label', 'Previous image'); prev.innerHTML = chevL;
      var next = document.createElement('button');
      next.type = 'button'; next.className = 'das-custom-arrow das-custom-arrow--next'; next.setAttribute('aria-label', 'Next image'); next.innerHTML = chevR;
      prev.addEventListener('click', function () { var n = slideshow.querySelector('.slideshow-control--previous'); if (n) n.click(); });
      next.addEventListener('click', function () { var n = slideshow.querySelector('.slideshow-control--next'); if (n) n.click(); });
      container.appendChild(prev);
      container.appendChild(next);
    }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', buildArrows); } else { buildArrows(); }
    setTimeout(buildArrows, 500);
  })();

  // Image counter badge ("1 / 7") in the gallery corner
  (function () {
    function setupCounter() {
      var slideshow = document.querySelector('.product-information slideshow-component, .product-information [class*="slideshow"]');
      if (!slideshow || slideshow.dataset.counterInit === 'true') return;
      var container = slideshow.querySelector('slideshow-container') || slideshow;
      var dots = slideshow.querySelectorAll('[aria-label^="Slide "]');
      var total = 0;
      if (dots.length) {
        var m = dots[0].getAttribute('aria-label').match(/of (\d+)/);
        total = m ? parseInt(m[1], 10) : dots.length;
      }
      var slides = slideshow.querySelectorAll('slideshow-slide, [class*="slide"]:not([class*="control"]):not([class*="slideshow-"])');
      if (!total) return;
      slideshow.dataset.counterInit = 'true';
      if (getComputedStyle(container).position === 'static') container.style.position = 'relative';
      var badge = document.createElement('div');
      badge.className = 'das-img-counter';
      var current = 1;
      function render() { badge.textContent = current + ' / ' + total; }
      render();
      container.appendChild(badge);
      // Update on dot/arrow interaction
      slideshow.addEventListener('click', function (e) {
        var dot = e.target.closest('[aria-label^="Slide "]');
        if (dot) {
          var dm = dot.getAttribute('aria-label').match(/Slide (\d+)/);
          if (dm) { current = parseInt(dm[1], 10); render(); }
          return;
        }
        if (e.target.closest('.slideshow-control--next')) { current = current % total + 1; render(); }
        if (e.target.closest('.slideshow-control--previous')) { current = (current - 2 + total) % total + 1; render(); }
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setupCounter);
    } else {
      setupCounter();
    }
    setTimeout(setupCounter, 500);
  })();

  // Item Details collapsible (open by default; toggle on header click)
  (function () {
    document.addEventListener('click', function (e) {
      var head = e.target.closest('.das-item-details__head');
      if (!head) return;
      var box = head.closest('product-item-details');
      if (!box) return;
      var open = box.getAttribute('data-open') === 'true';
      box.setAttribute('data-open', open ? 'false' : 'true');
      head.setAttribute('aria-expanded', open ? 'false' : 'true');
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
